// Raw asset paths, NOT ready-to-use urls. BackgroundImage resolves its `src`
// through getAssetUrl itself, so pass these to it as is; every other consumer
// (e.g. a plain <img src>) has to wrap them in getAssetUrl by hand, otherwise
// the CDN prefix and the content hash are lost and the image 404s outside local.
export const playUiAssets = {
    bubbleBackground: '/assets/maintenance/bubble.png',
    overlayBackground: '/assets/maintenance/gameOff_BG.jpg',
    bunny: '/assets/maintenance/npc_bunny.png',
    chicken: '/assets/maintenance/npc_chicken.png',
    parrot: '/assets/maintenance/npc_parrot.png',
} as const
